module.exports = __webpack_public_path__ + "static/media/carrot-feature.cbd2492f.jpg";